module.exports = __webpack_public_path__ + "img/img18.d54edd0b.jpg";